import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class LocalService {

    constructor() {
    }

    /**
     * 精确乘法
     * @param value1 第一个乘数
     * @param value2 第二个乘数
     * @returns 两数之积
     */
    mathMultiply(value1: number, value2: number): number {
        // 将浮点数转换为字符串
        let aStr = value1.toString();
        let bStr = value2.toString();

        // 找到小数点后的位置
        let aDecimals = (aStr.split('.')[1] || '').length;
        let bDecimals = (bStr.split('.')[1] || '').length;

        // 将浮点数转换为整数
        let aInt = parseInt(aStr.replace('.', ''));
        let bInt = parseInt(bStr.replace('.', ''));

        // 进行整数乘法
        let resultInt = aInt * bInt;

        // 计算最终的小数位数
        let totalDecimals = aDecimals + bDecimals;

        // 将结果转换回浮点数
        return resultInt / Math.pow(10, totalDecimals);
    }
    
    /**
     * 保留指定小数位数的百分比
     * @param num 需要处理的数值
     * @param len 要保留的小数位数
     * @returns 处理后的百分比值，保留指定小数位数
     */
    retainPercentDecimal(num: number, len: number): number {
        const n = Math.pow(10, len + 2);
        return this.mathMultiply(Math.round(num * n) / n, 100);
    }


    // ---------------------日期类---------------------

    /**
     * 格式化时间
     * @param type 格式化类型yyyy-MM-dd HH:mm:ss，注意MM为月份、mm为分钟
     * @param time 可选。默认当前时间
     * @returns yyyy-MM-dd HH:mm:ss
     */
    formatDate(type: string, time?: any): string {
        if (!time) {
            time = new Date();
        } else {
            time = new Date(time);
        }
        if (!type) {
            return '';
        }
        const year = time.getFullYear();
        const month = (time.getMonth() + 1).toString().padStart(2, '0');
        const date = (time.getDate()).toString().padStart(2, '0');
        const hours = (time.getHours()).toString().padStart(2, '0');
        const minute = (time.getMinutes()).toString().padStart(2, '0');
        const second = (time.getSeconds()).toString().padStart(2, '0');

        return type.replace('yyyy', year).replace('MM', month).replace('dd', date).replace('HH', hours).replace('mm', minute).replace('ss', second);
    }

    /**
     * 获取两日期间的所有日期
     * @param startDate 开始日期
     * @param endDate 结束日期
     * @returns 日期数组
     */
    getRangeDate(startDate: Date, endDate: Date): Date[] {
        let datesArray = [];
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            datesArray.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return datesArray;
    }
}

